var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('single-select',{ref:"content",attrs:{"list":_vm.list},on:{"confirm":_vm.onConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }